import { useEffect, useState } from 'react'
import ListDragByConfig from '../../DragAndDropList/presents/ListDragByConfig'
import EditPrintTypesDragSwitch from './EditPrintTypesDragSwitch'
import ListDropItems from '../../DragAndDropList/presents/ListDropItems'
import { MOVIE } from '../../../constants/itemTypes'
import ButtonSubmit from '../../general/ButtonSubmit'
import requestStatus from '../../../constants/requestStatus'
import Translation from '../../Translation/cont/Translation'
import MoviesFilterActionsContainer from '../../DragAndDropList/cont/MoviesFilterActionsContainer'
import WrapperPageSpinner from '../../WrapperPage/present/WrapperPageSpinner'
import { SHOWCASEPREVIEWMOVIE, SHOWCASEREDUCED, WEEKPOSTER } from '../../../constants/printType'
import createUrlFromIds from '../../../functions/createUrlfromIds'
import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import ChooseStartEndDateContainer from '../cont/ChooseStartEndDateContainer'

const conditionalWrapper = () => (children) => (
    <div className="periode-list">
        <div className="periode-item-container">
            {children}
        </div>
    </div>
)

const EditPrintTypes = ({
    printTypeNameTransId,
    printFormatNameTransId,
    status,
    errorMsg,
    basicUrl,
    features,
    selectedItems,
    printType,
    printPk,
    cinemaId,
    printFormat,
    activeWeek,
    activeTechnical,
    landscape,
    dateSettings,
    customHeadtext,
    setPreviewMovieHeadtext,

    closePagePath,
    dragListConfig,
    movieFilterConfig,
    itemsData,
    itemsDataCallback,

    displayDropzones,
    disableButton,

    onAddItem,
    onReorderItem,
    onDeleteItem,
    onPdfRequest,
    onPdfReset
}) => {
    const [headText, setHeadtext] = useState(customHeadtext)

    useEffect(() => {
        if(customHeadtext !== headText) {
            setHeadtext(customHeadtext)
        }
    }, [customHeadtext])

    const pageName = [<Translation key="name" id={printTypeNameTransId} after=" in "/>, <Translation key="format" id={printFormatNameTransId}/>]
    const listId = 'fooo'  /// ??? ToDo    
    const queryString = createUrlFromIds(selectedItems)
    const displayDropzonesClass = displayDropzones ? ' dropzones single-dropzone' : ''
    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printFormat, landscape: landscapeBoolean })
    const path = `${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${currentPrintFormat.landscape}`
    const { INITIALIZED, REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatus
    let buttonTextTransId

    if(INITIALIZED === status) {
        buttonTextTransId = 'print_generate_PDF'
    } else if(REQUEST_PENDING  === status) {
        buttonTextTransId = 'print_PDF_is_generated'

    } else if(REQUEST_SUCCESS === status)  {
        buttonTextTransId = 'print_PDF_was_generated'
    } else {
        buttonTextTransId = 'print_PDF_error'
    }

    return (
        <WrapperPageSpinner
            pageTitle={pageName}
            closePagePath={closePagePath}
        
            pending={REQUEST_PENDING  === status}
            error={REQUEST_ERROR === status}
            success={REQUEST_ERROR === status}
        
            pendingTextTransId='print_PDF_is_generated'
            errorTextTransId='print_error_occurred_while_generating'
            successTextTransId='print_PDF_successfully_generated'
            
            errorMsg={errorMsg ? errorMsg.message : ''}
            successMsg='Es befindet sich in dem Downloadordner oder ist über die Downloadhistorie des Browsers zu finden. Je nach Downloadeinstellung kann sich der Speicherort unterscheiden.'
        
            onClickSuccesButton={onPdfReset}
            onClickErrorButton={onPdfReset}
        >
            <div className="program-page program-page-edit-selection site-content">
                {activeWeek === 'custom' && !dateSettings ? (
                    <div>
                        <h3 className="title-list text-regular"><Translation id="print_flyer_custom_date_period_title">Eigener Zeitraum</Translation></h3>
                        <h4 className="gap-20 text-regular"><Translation id="print_flyer_select_start_end_date">Start- und Enddatum auswählen</Translation></h4>
                        <ChooseStartEndDateContainer
                            printPk={printPk}
                            printType={printType}
                            path={`${path}/custom/edit`}
                            flyerServerData={null}
                        />
                    </div>
                ) : (
                    ((printType === SHOWCASEREDUCED && features && features.has_showcaseReduced) || printType !== SHOWCASEREDUCED) ? (
                        <div className="selections-item">
                            <div className="selections-item-content accordion-item">
                                <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/></p>
    
                                <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                                    {printType === SHOWCASEPREVIEWMOVIE && <div>
                                        <form className='gap-50'>
                                            <label className="field-text-label" htmlFor="preview-movie-headtext"><Translation id="print_flyer_heading"/></label>
                                            <input className="text-regular input-text-box gap-20" type="text" id="preview-movie-headtext" value={headText} onChange={(event) => setHeadtext(event.target.value)}/>

                                            <button className="button button-submit text-light" type="submit" onClick={() => setPreviewMovieHeadtext(headText)}><Translation id="save_button"/></button>
                                        </form>
                                    </div>}
                                    <MoviesFilterActionsContainer
                                        filterConfig={movieFilterConfig}
                                        listId={listId} ///? 
    
                                        relevantAttributes={itemsData.attributes}
                                        relevantMovies={itemsData.moviesOrder}
                                        currentMovies={itemsData.currentMovies}
                                        futureMovies={itemsData.futureMovies}
                                        selectedItems={itemsData.selectedItems}
                                        addItem={onAddItem}
                                        deleteItem={(listId, itemId, targetId) => onDeleteItem(itemId)}
                                    />
    
                                    <ListDragByConfig
                                        dragListConfig={dragListConfig}
                                        itemsData={itemsData}
                                        itemsDataCallback={itemsDataCallback}
                                        basicUrl={basicUrl}
                                        defaultIsOpen={true}
                                        ChildSwitchItem={EditPrintTypesDragSwitch}
                                        addNewItem={onAddItem}
                                        onDeleteItem={onDeleteItem}
                                    />
                                </div>
    
                                <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                                    <ListDropItems
                                        listId={listId} ///?
                                        title = ''
                                        basePreviewUrl={`${pmkinoClientVars.siteURL}/${config.routes.webtoprint.previewpath}/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}/${activeTechnical}/`}
                                        items={itemsData.moviesItems}
                                        order={itemsData.selectedItems}
                                        itemType={MOVIE}
                                        displayDropzones={displayDropzones}
                                        conditionalWrapper={conditionalWrapper}
                                        ChildSwitchItem={EditPrintTypesDragSwitch}
                                        basicUrl={basicUrl}
                                        canEdit={true}
                                        canDelete={true}
                                        addItem={onAddItem}
                                        reorderItem={onReorderItem}
                                        deleteItem={onDeleteItem}
                                    />
                                </div>
                            </div>
    
                            <div className={"buttons-submit-cancel save-program-button" + (disableButton ? " disabled" : "")}>
                                {(printType === WEEKPOSTER && !disableButton) && (
                                    <a
                                        className="button button-cancel" 
                                        href={`${pmkinoClientVars.siteURL}/${config.routes.webtoprint.previewpath}/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}/${activeTechnical}/${queryString}`}
                                        target="_blank"
                                    >
                                        <Translation id="button_preview">Vorschau</Translation>
                                    </a>
                                )}
                                <ButtonSubmit
                                    transIdSubmit={disableButton ? "select_movie_button" : buttonTextTransId}
                                    onSubmit={() => !disableButton && onPdfRequest()}
                                    disableTemporarily={disableButton}
                                    disablePermanently={false}
                                    hasFixedPositionWrapper={true}
                                />
                            </div>
                            
                        </div>
                    ) : (
                        <div>Dieses Feature ist nicht freigeschaltet. Bei Interesse kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                    )
                )
            }
            </div>
        </WrapperPageSpinner>
    )
}

export default EditPrintTypes

